import AuthHeader from 'components/other/AuthHeader';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Routes } from 'types/routeTypes';
import { handleAuth } from 'utils/authHelpers';
import 'twin.macro';
import Button from 'components/button/Button';

const SSOCallback = () => {
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const accessToken = urlParams.get('access_token');
  const refreshToken = urlParams.get('refresh_token');

  if (accessToken && refreshToken) {
    handleAuth('sso', {
      access_token: accessToken,
      refresh_token: refreshToken,
      email: urlParams.get('email')!,
      first_name: urlParams.get('first_name')!,
      last_name: urlParams.get('last_name')!,
      id: parseInt(urlParams.get('id')!),
      is_sympl: urlParams.get('is_sympl') === 'true',
      active_customer: parseInt(urlParams.get('active_customer')!),
      active_vacancy: urlParams.get('active_vacancy')
        ? parseInt(urlParams.get('active_vacancy')!)
        : undefined,
    });

    navigate(Routes.ROOT);
  }

  const error = urlParams.get('error');
  if (error) {
    return (
      <div tw="bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 h-screen">
        <AuthHeader />

        <div tw="mt-8 mx-auto w-full max-w-md">
          <div tw="bg-white p-10 shadow rounded-lg text-center">
            <p tw="my-4">{error}</p>
            <Button variant="link" onClick={() => navigate(Routes.LOGIN)}>
              Return to login
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <p>Loading... If this takes too long, please retry.</p>
    </div>
  );
};

export default SSOCallback;
